export const USER_KEY = 'user';
export const ACCESS_TOKEN_KEY = 'accessToken';
export const ACCESS_TOKEN_SUCCESS = 'accessTokenSuccess';
export const ACCESS_TOKEN_FAILED = 'accessFailed';
export const LOGIN_SUCCESS = 'loginSuccess';
export const LOGIN_FAILURE = 'loginFailure';
